const MIN_QUERY_LENGTH = 3;

export const isValidSearchQuery = (query = '') => {
  return query.length === 0 || query.length >= MIN_QUERY_LENGTH;
};

export const isCyrillic = (text = '') => {
  const CYRILLIC_REGEX = /^[\u0400-\u04FF\s\-']+$/i;
  return CYRILLIC_REGEX.test(text);
};
